import { useQueryClient, useMutation } from '@tanstack/react-query';
import { pm2ConfigStore } from '@pm2/store';
import { useUserIdentityState } from '@provider/user-identity';
import { getLastLocationDescriptorQuery } from './get-last-location.query.js';
import { updateLocationRequest } from './update-location.request.js';

function useUpdateLastLocationMutation() {
  const client = useQueryClient();
  const user = useUserIdentityState(state => state.user);
  const configStore = pm2ConfigStore.useStore();
  return useMutation(updateLastLocationMutation(client, configStore, user));
}
const updateLastLocationMutation = (client, configStore, user) => {
  return {
    mutationKey: ["user-area/location/update-last", user?.id],
    mutationFn: async descriptor => {
      if (!user) {
        return null;
      }
      const {
        config
      } = configStore.getState();
      const lastLocationDescriptor = client.getQueryData(getLastLocationDescriptorQuery.queryKey({
        configStore,
        portalId: config.id,
        user
      }));
      return updateLocationRequest(configStore.getState().config.id, user, descriptor, lastLocationDescriptor?.objectId);
    },
    onMutate: async input => {
      const {
        config
      } = configStore.getState();
      const prevDescriptor = client.getQueryData(getLastLocationDescriptorQuery.queryKey({
        configStore,
        portalId: config.id,
        user
      }));
      client.setQueryData(getLastLocationDescriptorQuery.queryKey({
        configStore,
        portalId: config.id,
        user
      }), prev => ({
        descriptor: input,
        objectId: prev?.objectId
      }));
      await client.cancelQueries({
        queryKey: getLastLocationDescriptorQuery.queryKey({
          configStore,
          portalId: config.id,
          user
        })
      });
      return {
        prevDescriptor
      };
    },
    onSuccess: data => {
      if (!data) {
        return;
      }
      const {
        config
      } = configStore.getState();
      client.setQueryData(getLastLocationDescriptorQuery.queryKey({
        configStore,
        portalId: config.id,
        user
      }), () => data);
    },
    onError: (error, input, ctx) => {
      const {
        config
      } = configStore.getState();
      client.setQueryData(getLastLocationDescriptorQuery.queryKey({
        configStore,
        portalId: config.id,
        user
      }), () => ctx?.prevDescriptor);
    }
  };
};

export { useUpdateLastLocationMutation };
//# sourceMappingURL=update-location.mutation.js.map
